import React, { Component } from 'react'
import { connect } from 'react-redux'

import './_textSwiper.css'

class TextSwiper extends Component {
  static defaultProps = {
    texts: [],
    index: 0,
    onTextChange: () => {}
  }

  render() {
    const { texts, index } = this.props

    var text = (index >= 0) ? texts[index].value : ''

    return (
      <div className="text-swiper">
        <div className="text-holder" dangerouslySetInnerHTML={{__html: text}}>
        </div>

        <button className="refresh" onClick={this.props.onTextChange}>Другой текст</button>  
      </div>
    );
  }
}

export default connect()(TextSwiper)


// WEBPACK FOOTER //
// ./src/components/text-swiper/TextSwiper.js